import {Indicators} from 'domain-models'

export type IndicatorsState = {
  filters: any
  filter: any
} & Indicators

type IndicatorAction = {
  filters: any
  indicators: Indicators
  type: string
  filter: any
  auctioned: number
}

const initialState = {
  filters: {},
  filter: null,
  auctioned: 0,
  highestBidder: 0,
  sumBids: 0,
  sumMaxBids: 0,
}

const indicatorReducer = (state: IndicatorsState = initialState, action: IndicatorAction) => {
  switch (action.type) {
    case 'FETCH_INDICATORS':
      return {
        ...state,
        ...action.indicators,
      }
    case 'SET_AUCTIONED_FILTER':
      return {
        ...state,
        filters: {...state.filters, auctioned: action.filter},
        auctioned: action.auctioned
      }
    default:
      return state
  }
}

export default indicatorReducer
